import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Flex, FormContext } from 'dash-ui';
import { RoleTypesEnum } from 'dash-common';

import { FormFields } from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/constants/constants';
import { useGetDevelopersAsSaleUsersBySaleTeamAndRoleQuery } from 'gql/generated.graphql';

const SaleDirectorSelect = ({
  saleTeamIndex,
  disabled,
}: {
  saleTeamIndex: number;
  disabled?: boolean;
}) => {
  const { t } = useTranslation(['forms', 'common', 'pages']);
  const { formErrors, formState, stateHandlers } = useContext(FormContext);

  const { saleTeamId, saleDirectorId = undefined } =
    formState[FormFields.SaleTeams][saleTeamIndex];

  const { data, loading } = useGetDevelopersAsSaleUsersBySaleTeamAndRoleQuery({
    variables: {
      saleTeamId,
      roleType: RoleTypesEnum.ORG_SALES_DIRECTOR as any,
    },
    skip: !saleTeamId,
    fetchPolicy: 'network-only',
  });

  const users = data?.getDevelopersAsSaleUsersBySaleTeamAndRole || [];

  const onSelectChange = (value: any) => {
    const saleTeams = [...formState[FormFields.SaleTeams]];

    saleTeams[saleTeamIndex] = {
      ...saleTeams[saleTeamIndex],
      saleDirectorId: value,
    };

    stateHandlers[FormFields.SaleTeams](saleTeams);
  };

  return (
    <Flex flexDirection="column" mr={2} flex={1}>
      <Form.Label>{t('forms:labels.salesDirector')}</Form.Label>
      <Form.Select
        isClearable
        menuPortalZIndex="auto"
        options={users.map((item) => ({
          value: item._id,
          label: item.profile.lastName
            ? `${item.profile.firstName} ${item.profile.lastName}`
            : item.profile.firstName,
        }))}
        isLoading={loading}
        value={saleDirectorId || undefined}
        disabled={!saleTeamId || disabled}
        placeholder={t('forms:placeholders.salesDirector')}
        w="100%"
        $errorType={
          formErrors[FormFields.SaleTeams]?.[saleTeamIndex]?.saleDirectorId
            ?.type
        }
        onChanged={onSelectChange}
      />
      <Form.Feedback
        $errorType={
          formErrors[FormFields.SaleTeams]?.[saleTeamIndex]?.saleDirectorId
            ?.type
        }
      >
        {
          formErrors[FormFields.SaleTeams]?.[saleTeamIndex]?.saleDirectorId
            ?.message
        }
      </Form.Feedback>
    </Flex>
  );
};

export default SaleDirectorSelect;
